import { useStringFlagValue } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../constants/featureFlag";

export function useDynamicPaywallProductId(): string {
  return useStringFlagValue(FeatureFlagVariables.dynamicPaywallProductId, "");
}
